import { render, staticRenderFns } from "./FormOptionalLabel.vue?vue&type=template&id=04a09b62&scoped=true&"
import script from "./FormOptionalLabel.vue?vue&type=script&lang=js&"
export * from "./FormOptionalLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormOptionalLabel.vue?vue&type=style&index=0&id=04a09b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a09b62",
  null
  
)

export default component.exports